<template>
  <div class="home">
    <div class="carousel">
      <el-carousel ref="carousel" @mouseenter.native="autoplayHandle" arrow="always">
        <el-carousel-item v-for="item in imgList" :key="item.id" >
          <!-- <img :src="item.src" class="image"/> -->
          <div class="img-wrap">
            <img :src="item.src" class="image"/>
            <router-link to="/service/purpose" class="link" :class="{ link1: item.id == 0  }">
                <img src="../../assets/images/home/btn_more_whi.png" @click="handleNav(0)" />
            </router-link>
            <router-link to="/service/spirit" class="link" :class="{ link2: item.id == 1  }">
                <img src="../../assets/images/home/btn_more_whi.png" @click="handleNav(1)" />
            </router-link>
            <router-link to="/service/mission" class="link" :class="{ link3: item.id == 2  }">
                <img src="../../assets/images/home/btn_more_whi.png" @click="handleNav(2)" />
            </router-link>
            <router-link to="/service/strength" class="link" :class="{ link4: item.id == 3  }">
                <img src="../../assets/images/home/btn_more_whi.png" @click="handleNav(3)" />
            </router-link>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="img-list">
      <div class="img-item">
        <img src="../../assets/images/home/banner_2.png" />
        <router-link to="/theSeven" class="link link1">
          <img src="../../assets/images/home/btn_more_ql.png" @click="handleLink('/theSeven')" />
        </router-link>
      </div>
      <div class="img-item">
        <img src="../../assets/images/home/banner_3.png" />
        <router-link to="/team" class="link link2">
          <img src="../../assets/images/home/btn_more_blu.png" @click="handleLink('/team')" />
        </router-link>
      </div>
      <div class="img-item">
        <img src="../../assets/images/home/banner_4.png" />
        <router-link to="/triTone" class="link link3">
          <img src="../../assets/images/home/btn_more_ql.png" @click="handleLink('/triTone')" />
        </router-link>
      </div>
      <div class="img-item">
        <img src="../../assets/images/home/banner_5.png" />
        <router-link to="/groupStrength" class="link link4">
          <img src="../../assets/images/home/btn_more_whi.png" @click="handleLink('/groupStrength')" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Bus from '../../utils/eventBus.js'
export default {
  name: 'home',
  data() {
    return {
      imgList: [
        { id: 0, src: require("../../assets/images/home/banner_lb_1.png") },
        { id: 1, src: require("../../assets/images/home/banner_lb_2.png") },
        { id: 2, src: require("../../assets/images/home/banner_lb_3.png") },
        { id: 3, src: require("../../assets/images/home/banner_lb_4.png") }
      ]
    }
  },
  mounted() {
    this.$refs.carousel.handleMouseEnter = () => {
      console.log('修改成功')
    }
  },
  methods: {
    handleNav(id) {
      var to = '/service'
      if(id == 0){
        to = '/service/purpose'
      }else if(id == 1){
        to = '/service/spirit'
      }else if(id == 2){
        to = '/service/mission'
      }else if(id == 3){
        to = '/service/strength'
      }
      Bus.$emit('pageName', to)
      console.log('111')
    },
    handleLink(pageName) {
      console.log(pageName)
      Bus.$emit('pageName', pageName)
    },
    autoplayHandle() {
      // this.$refs.carousel.handleMouseEnter = () => {
      //   console.log('修改成功')
      // }
      // console.log(this.$refs.carousel.handleMouseEnter)
      // this.$refs.carousel.handleMouseEnter()
    },
  }
}
</script>
<style lang="scss" scoped>
  .carousel {
    .img-wrap {
      width: 100%;
      height: 855px;
      position: relative;
      overflow: hidden;
      .link {
        position: absolute;
        width: 178px;
        height: 52px;
        img {
          width: 178px;
          height: 52px;
        }
      }
      .link1 {
        bottom: 200px;
        left: 281px;
      }
      .link2 {
        left: 493px;
        bottom: 229px;
      }
      .link3 {
        left: 871px;
        bottom: 120px;
      }
      .link4 {
        left: 532px;
        bottom: 180px;
      }
    }
    .image {
      width: 100%;
      height: 855px;
    }
  }
  .img-list {
    .img-item {
      width: 100%;
      height: 855px;
      position: relative;
      img {
        width: 100%;
        height: 855px;
      }
      .link {
        position: absolute;
        width: 178px;
        height: 52px;
        img {
          width: 178px;
          height: 52px;
        }
      }
      .link1 {
        left: 871px;
        bottom: 120px;
      }
      .link2 {
        left: 927px;
        bottom: 120px;
      }
      .link3 {
        left: 871px;
        bottom: 100px;
      }
      .link4 {
        left: 1226px;
        bottom: 150px;
      }
    }
  }
</style>
<style scoped>
  .carousel /deep/ .el-carousel__container {
    height: 855px;
  }
</style>
